module.exports = __webpack_public_path__ + "static/img/v30_08.c5210c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/v30_08.jpg
// module id = +gIc
// module chunks = 3